module.exports = __webpack_public_path__ + "static/img/02.14e061b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/cdzj/02.png
// module id = kuQ/
// module chunks = 0